import { Component } from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { ConferenceData } from '../../providers/conference-data';

import { SessionDetailPage } from '../session-detail/session-detail';
import { SpeakerDetailPage } from '../speaker-detail/speaker-detail';
import {LoggerService} from '../../providers/logger-service';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-speaker-list',
  templateUrl: 'speaker-list.html'
})
export class SpeakerListPage {
  actionSheet: ActionSheet;
  speakers: any[] = [];

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public navCtrl: NavController,
    public confData: ConferenceData,
    public config: Config,
    public inAppBrowser: InAppBrowser,
    private logger: LoggerService
  ) { }

  ionViewDidLoad() {
    this.confData.getSpeakers().subscribe((speakers: any[]) => {
      this.speakers = speakers;
    });

    dataLayer.push({
      'screenPath': 'speaker-list',
      'screenName': 'SpeakerListPage'
    });
    dataLayer.push({'event': 'appScreenView'});

  }

  goToSessionDetail(session: any) {
    this.navCtrl.push(SessionDetailPage, {
      name: session.name,
      session: session
    });

    dataLayer.push({
      'appEventCategory': 'speaker-list',
      'appEventAction': 'goToSessionDetail',
      'appEventLabel': 'goToSessionDetail button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  goToSpeakerDetail(speakerName: any) {
    this.navCtrl.push(SpeakerDetailPage, {
      speaker: speakerName,
      name: speakerName.name
    });


    dataLayer.push({
      'appEventCategory': 'speaker-list',
      'appEventAction': 'goToSpeakerDetail',
      'appEventLabel': 'goToSpeakerDetail button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  goToSpeakerTwitter(speaker: any) {
    this.inAppBrowser.create(`https://twitter.com/${speaker.twitter}`, '_blank');

    dataLayer.push({
      'appEventCategory': 'speaker-list',
      'appEventAction': 'goToSpeakerTwitter',
      'appEventLabel': 'goToSpeakerTwitter button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  openSpeakerShare(speaker: any) {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Share ' + speaker.name,
      buttons: [
        {
          text: 'Copy Link',
        //   handler: ($event: Event) => {
        //     this.logger.log.debug('Copy link clicked on https://twitter.com/' + speaker.twitter);
        //     if ((window as any)['cordova'] && (window as any)['cordova'].plugins.clipboard) {
        //       (window as any)['cordova'].plugins.clipboard.copy('https://twitter.com/' + speaker.twitter);
        //     }
        //   }
        },
        {
          text: 'Share via ...',
          handler: () => {
            console.log('Share clicked');
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('cancel clicked');
          }
        }
      ]
    });

    actionSheet.present();

    dataLayer.push({
      'appEventCategory': 'speaker-list',
      'appEventAction': 'openSpeakerShare',
      'appEventLabel': 'openSpeakerShare button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  openContact(speaker: any) {
    let mode = this.config.get('mode');

    let actionSheet = this.actionSheetCtrl.create({
      title: 'Contact ' + speaker.name,
      buttons: [
        {
          text: `Email ( ${speaker.email} )`,
          icon: mode !== 'ios' ? 'mail' : null,
          handler: () => {
            window.open('mailto:' + speaker.email);
          }
        },
        {
          text: `Call ( ${speaker.phone} )`,
          icon: mode !== 'ios' ? 'call' : null,
          handler: () => {
            window.open('tel:' + speaker.phone);
          }
        }
      ]
    });

    actionSheet.present();

    dataLayer.push({
      'appEventCategory': 'speaker-list',
      'appEventAction': 'openContact',
      'appEventLabel': 'openContact button'
    });
    dataLayer.push({'event': 'appEvent'});
  }


}



// WEBPACK FOOTER //
// ./src/pages/speaker-list/speaker-list.ts